module.exports = __webpack_public_path__ + "static/media/temp card.a75e3430.svg";